"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
/*** node_modules **/
require("jquery.easing");
// import 'jquery.transit';
/*** ./modules **/
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
$(function () {
    new linker_1.default({
        extendLink: '.sw-ExtendLink'
    });
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll'
    });
    $('.st-Menu').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).toggleClass('-expanded');
        $('#Sub').toggleClass('-expanded');
    });
    var userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        $('body').addClass('ie');
    }
    ;
    $('.more-link').each(function (i, elem) {
        var $p = $(elem).closest('p');
        var $clone = $p.clone(true);
        var $article = $(elem).closest('article');
        $p.remove();
        $article.append($clone);
    });
    $('article a[href*=".png"], article a[href*=".PNG"], article a[href*=".jpg"], article a[href*=".JPG"], article a[href*=".gif"], article a[href*=".GIF"], article a[href*=".jpeg"], article a[href*=".JPEG"]').fancybox({
        buttons: [
            "close"
        ]
    });
});
